import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';

import {
  ButtonColorWrapper,
  ButtonStyled
} from './TradeShowButton.style';

const TradeShowButton = ({url, headerColor, orderNowButtonText}) => {
  return (
    <ButtonColorWrapper headerColor={headerColor}>
      <ButtonStyled to={url}>
        <FormattedMessage id={orderNowButtonText} />
      </ButtonStyled>
    </ButtonColorWrapper>
  );
};

TradeShowButton.propTypes = {
  url: PropTypes.string.isRequired,
  headerColor: PropTypes.string.isRequired,
  orderNowButtonText: PropTypes.string.isRequired
};
export default TradeShowButton;



// WEBPACK FOOTER //
// ./components/TradeShowButton/TradeShowButton.js